import moment from 'moment'

function formatDate(date, format) {
    if (!date) {
        return ''
    }

    date = moment(date)

    if (!date.isValid()) {
        return ''
    }

    return date.format(format)
}

const dateFormat = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'numeric', year: 'numeric' })
const timeFormat = new Intl.DateTimeFormat('en-US', { hour12: true, hour: 'numeric', minute: '2-digit' })

export function formatLocalTime(date) {
    date = new Date(date)
    return `${dateFormat.format(date)} ${timeFormat.format(date)}`
}

export function formatNumber(number, options) {
    return (number ?? 0).toLocaleString('en-US', options)
}

export function formatCurrency(amount, options) {
    if (amount === null || amount === undefined) {
        return ''
    }

    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD', ...options })
}

export function formatNegativeParens(value, options) {
    if (value < 0) {
        value = -value

        return `(${value.toLocaleString([], options)})`
    }

    return value.toLocaleString([], options)
}

export function formatMarketCapNumber(marketCap, currency) {
    return (
        (marketCap / 1000).toLocaleString('en-US', {
            style: 'currency',
            currency: currency || 'USD',
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        }) + 'B'
    )
}

export function iso8601Date(date) {
    if (!date) {
        return null
    }

    return new Date(date).toISOString().substring(0, 10)
}

export function hitRate(hitRate) {
    if (hitRate) {
        return `${(hitRate.rate * 100).toFixed(0)}% (${hitRate.positive}/${hitRate.count})`
    }

    return 'N/A'
}

export function shortDate(date) {
    return formatDate(date?.substring(0, 10), 'D-MMM-YY')
}

export function pluralize(n, singular = '', plural = 's') {
    return n === 1 ? singular : plural
}

export function percentage(value, options = {}) {
    if (!value) {
        return '-'
    }

    options = { minimumFractionDigits: 1, maximumFractionDigits: 1, ...(options ?? {}), style: 'percent' }

    return formatNegativeParens(value, options)
}

export function monthDayYear(date) {
    return formatDate(date, 'M/D/YYYY')
}

export const compensationFormats = {
    currency(value, options) {
        return formatCurrency(value, { maximumFractionDigits: 0, ...options })
    },
    percentage(value) {
        if (value > 0 && value < 0.01) {
            return '< 1%'
        }
        return value.toLocaleString('en-us', { style: 'percent', maximumFractionDigits: 0 })
    },
}

export function longDateFromFuzzyDate(date) {
    if (!date || !date.year) {
        return ''
    }

    if (!date.month) {
        return date.year
    }

    var format = 'll'

    if (!date.day) {
        date = Object.assign({}, date, { day: 1 })
        format = 'MMM, YYYY'
    }

    return formatDate(date, format)
}

export function formatDateRange(start, end, format) {
    let formattedStart = formatDate(start, format || 'MMM YYYY')
    let formattedEnd = formatDate(end, format || 'MMM YYYY')

    if (!formattedStart && !formattedEnd) {
        return ''
    }

    return `${formattedStart || 'N/A'} - ${formattedEnd || 'N/A'}`
}
